import Mention from './_mention';
import MentionOption from './mention-option';

Mention.MentionOption = MentionOption;

export default Mention;
